import RestResource from '../rest.service';

export default class DocumentsService extends RestResource {
  map(payload) {
    let formData = new FormData();

    formData.append('documentable_id', payload.documentableId);
    formData.append('documentable_type', payload.documentableType);
    formData.append('document', payload.document);
    formData.append('document_name', payload.documentName);
    formData.append('type', payload.documentType);
    formData.append('description', payload.description);
    formData.append('order_id', payload.orderId);
    formData.append('receipt_type_id', payload.receiptTypeId);

    return formData;
  }

  constructor() {
    super('documents');
  }
}
